<template>
  <small>{{ $t('commonText.optional') }}</small>
</template>

 <script>
  export default {
    name: 'form-optional-label'
  }
</script>

<style lang="scss" scoped>
  small {
    font-size: 10px;
    font-style: italic;
    float: right;
    margin-top: 3px;
  }
</style>
